import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { ConfigProvider } from "@h3/antd-vue";
import OAuthApi from "@/apis/oauth";
import env from "@/config/env";
import zhCN from "@h3/antd-vue/lib/locale-provider/zh_CN";
import enUS from "@h3/antd-vue/lib/locale-provider/en_US";
import app from "@cloudpivot/common/src/constants/globalApplication";
import 'moment/locale/zh-cn';
import { updateTheme } from './tools/settingConfig';
import { themesApi } from "@cloudpivot/api";
import getDownloadUrlNew from '@cloudpivot/common/src/utils/getDownloadUrlNew';
let App = class App extends Vue {
    get locale() {
        switch (this.$i18n.locale) {
            case "zh":
            default:
                // return require('@h3/antd-vue/lib/locale-provider/zh_CN');
                return zhCN;
            case "en":
                // return require('@h3/antd-vue/lib/locale-provider/en_US');
                return enUS;
        }
    }
    get isIe() {
        if (window.Environment && window.Environment.isIe !== undefined) {
            return window.Environment.isIe;
        }
        return false;
    }
    mounted() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield OAuthApi.getSystemConfig();
            if (config) {
                config.apiHost = env.apiHost;
                this.$store.commit("setConfig", config);
            }
            app.errorManager.getErrorCode();
            // console.log('进入页面...',window.name)
            // var isDingtalk = /DingTalk/.test(navigator.userAgent)
            // if(!isDingtalk){
            //   // 关闭所有标签清空token
            //   //从钉钉打开不清除token
            //   let T = sessionStorage.getItem('T')
            //   if(!window.name&&!T){
            //     let openTabCountOld:any = localStorage.getItem('openTabCount')||0
            //     console.log('openTabCountOld',openTabCountOld)
            //     if(openTabCountOld&&Number(openTabCountOld)<=0){
            //        const redirectIP = process.env.portalHost;
            //       let redirectUrl = `${redirectIP}/login`;
            //       localStorage.removeItem("token");
            //       localStorage.removeItem("refresh_token");
            //       localStorage.removeItem("expireTime");
            //       sessionStorage.removeItem("user");
            //       localStorage.removeItem("syncTaskId");
            //       localStorage.removeItem("orgPartSync");
            //       localStorage.removeItem('openTabCount')
            //       window.location.href = redirectUrl;
            //     }
            //   }
            //   // 刷新
            //   window.onunload = function (){
            //     console.log('onunload')
            //       let openTabCount:any = localStorage.getItem('openTabCount')
            //       if(openTabCount&&Number(openTabCount)>0){
            //         openTabCount = Number(openTabCount)-1;
            //         localStorage.setItem('openTabCount',openTabCount)
            //       }
            //       // localStorage.setItem(`openTabCount${openTabCount}`, openTabCount)
            //       // else{
            //       //   openTabCount =0
            //       // }
            //   }
            //   // dom加载记录
            //   document.onreadystatechange = function () {
            //     console.log('onready',document.readyState)
            //     window.name = 'reload'
            //     if (document.readyState === 'complete') {
            //       let openTabCount:any = localStorage.getItem('openTabCount') || 0
            //       openTabCount = Number(openTabCount)+1;
            //       localStorage.setItem('openTabCount',openTabCount)
            //     }
            //   }
            // }
        });
    }
    created() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield themesApi.getThemesInfo().then((res) => {
                this.$store.commit('setThemsConfig', res);
                if (res.icon) {
                    this.changeFavicon(this.getIcon(res.icon));
                    if (res.name && document.title.indexOf('奥哲云枢-') !== -1) {
                        document.title = document.title.replace('奥哲云枢-', res.name + '-');
                    }
                    else if (res.name && document.title.indexOf('云枢-') !== -1) {
                        document.title = document.title.replace('云枢-', res.name + '-');
                    }
                }
                if (res.name) {
                    localStorage.setItem('themsInfo', JSON.stringify({ title: res.name, }));
                }
                else {
                    localStorage.removeItem('themsInfo');
                }
                updateTheme({
                    color: res.color || 'default',
                    outwardType: res.outward || 'light',
                    store: this.$store
                });
            });
        });
    }
    // 修改浏览器标签页上的小图标
    changeFavicon(link) {
        if (!link) {
            return;
        }
        let $favicon = document.querySelector('link[rel="icon"]');
        if ($favicon !== null) {
            $favicon.href = link;
        }
        else {
            $favicon = document.createElement("link");
            $favicon.rel = "icon";
            $favicon.href = link;
            // @ts-ignore
            document.head.appendChild($favicon);
        }
    }
    getIcon(refId) {
        return refId ? this.getDownloadUrlByRefId(refId) : '';
    }
    getDownloadUrlByRefId(refId) {
        return getDownloadUrlNew.getImageUrl(refId, 'logo');
    }
};
App = tslib_1.__decorate([
    Component({
        components: {
            AConfigProvider: ConfigProvider,
        },
    })
], App);
export default App;
